import { filter } from 'lodash';

const multiFactorTitleMapping = {
  MFA: 'Authenticator app',
};

export const mfaMethodsList = (state) => _getMethodsListUI(state, null);

export const enabledMFAMethods = (state) => _getMethodsListUI(state, { isEnabled: true });

export const availableMFAMethods = (state) => _getMethodsListUI(state, { isEnabled: false });

function _getMethodsListUI(state, query) {
  const list = (query ? filter(state.twoFactorMethodsList, query) : state.twoFactorMethodsList);

  let methods = [];

  list.forEach(method => {
    methods.push({
      label: multiFactorTitleMapping[method.type] || method.type,
      id: method.type,
      selectable: true
    });
  });

  return methods;
}
